<div class="row">
   <div class="col-md-12">
      <div class="card">
         <div class="row">
            <div class="col-md-12">
               <h1 class="headingValue">Permisssion For Temporary Registration (PTR) Application Form</h1>
            </div>
         </div>
         <div class="bt-tab-content-main">
            <div class="tab-content" style="margin-top: 15px">
               <div id="signin">
                  <div class="col-md-12">
                     <h5 class="headingValue">Applicant Information</h5>
                     <hr>
                     <div class="row" *ngIf="userDetails?.certificateRegistration!=null && userDetails?.certificateRegistration!=''">
                        <div class="col-md-6">
                           <div class="form-group">
                              <label for="phoneNo" class="required">Registration Number <span
                                 class="text-danger">:</span>&nbsp;{{userDetails?.certificateRegistration}}</label>
                           </div>
                        </div>
                     </div>
                     <div class="row">
                        <div class="col-md-6">
                           <div class="form-group">
                              <label for="grivFirstName" class="required">Applicant Name <span
                                 class="text-danger">:</span>&nbsp;{{userDetails?.name}}</label>
                           </div>
                        </div>
                     </div>
                     <div class="row">
                        <div class="col-md-6">
                           <div class="form-group">
                              <label for="grivFirstName" class="required">Email Address <span
                                 class="text-danger">:</span>&nbsp;{{userDetails?.userEmail}}</label>
                           </div>
                        </div>
                     </div>
                     <div class="row">
                        <div class="col-md-6">
                           <div class="form-group">
                              <label for="phoneNo" class="required">Mobile Number <span
                                 class="text-danger">:</span>&nbsp;{{userDetails?.mobileNumber}}</label>
                           </div>
                        </div>
                     </div>
                     <div class="row">
                        <div class="col-md-6">
                           <div class="form-group">
                              <label for="phoneNo" class="required">Address <span
                                 class="text-danger">:</span>{{userDetails?.addressLine1}}<span *ngIf="userDetails?.addressLine1 !== ''">,</span> 
                              {{userDetails?.addressLine2}}<span *ngIf="userDetails?.addressLine2 !==''">,</span>
                              {{userDetails?.stateName}}<span *ngIf="userDetails?.stateName !== ''">,</span>
                              {{userDetails?.cityName}}<span *ngIf="userDetails?.cityName !== ''">,</span> 
                              {{userDetails?.countryName}} <span *ngIf="userDetails?.countryName !== ''">-</span> 
                              {{userDetails?.pinCode}}<span *ngIf="userDetails?.pinCode !== ''">.</span></label>
                           </div>
                        </div>
                     </div>
                     <div class="row">
                        <div class="col-md-6">
                           <div class="form-group">
                              <label for="phoneNo" class="required">Purpose of Inviting Foreign Dentist <span
                                 class="text-danger">:</span>&nbsp;{{userDetails?.purposeConducting}}</label>
                           </div>
                        </div>
                     </div>
                     <div class="row">
                        <div class="col-md-6">
                           <div class="form-group">
                              <label for="phoneNo" class="required">Venue of Program <span
                                 class="text-danger">:</span>&nbsp;{{userDetails?.venueProgram}}</label>
                           </div>
                        </div>
                     </div>
                  </div>
                  <div class="col-md-12">
                     <h5 class="headingValue">Invitee List</h5>
                     <hr>
                     <div class="row" style="overflow-x:auto;">
                        <div class="col-md-12">
                           <div class="table-responsive-sm">
                              <table class="table table-bordered table-hover">
                                 <thead class="thead-light">
                                    <tr>
                                       <th width="5%">S.No</th>
                                       <th width="15%">Invitee Name</th>
                                       <th width="20%">Email ID</th>
                                       <th width="15%">Mobile Number</th>
                                       <th width="25%">Address</th>
                                    </tr>
                                 </thead>
                                 <tbody class="tbodyRow">
                                    <tr *ngFor="let user of userDetails?.inviteeList;let i= index">
                                       <td>{{i+1}}</td>
                                       <td>{{user.inviteeName}}</td>
                                       <td>{{user.userEmail}}</td>
                                       <td>{{user.mobileNumber}}</td>
                                       <td>
                                          {{user.addressLine1}}<span *ngIf="user.addressLine1 !== ''">,</span> 
                                          {{user.addressLine2}}<span *ngIf="user.addressLine2 !==''">,</span><br>
                                          {{user.stateName}}<span *ngIf="user.stateName !== ''">,</span>
                                          {{user.cityName}}<span *ngIf="user.cityName !== ''">,</span> 
                                          {{user.countryName}} <span *ngIf="user.countryName !== ''">-</span> 
                                          {{user.pinCode}}<span *ngIf="user.pinCode !== ''">.</span>
                                       </td>
                                    </tr>
                                 </tbody>
                              </table>
                           </div>
                        </div>
                     </div>
                     <div class="row">
                        <div class="col-md-6">
                           <div class="form-group">
                              <label for="grivFirstName" class="required">Number of Invitee <span
                                 class="text-danger">:</span>&nbsp;{{userDetails?.inviteeList.length}}</label>
                           </div>
                        </div>
                     </div>
                     <div class="row">
                        <div class="col-md-6">
                           <div class="form-group">
                              <label for="grivFirstName" class="required">Total Amount <span
                                 class="text-danger">:</span>&nbsp;({{userDetails?.inviteeList.length}} x 3000) + 18% GST = &nbsp;{{totalAmountGST}} </label>
                           </div>
                        </div>
                     </div>
                     <div class="row">
                        <div class="form-group">
                           <br>
                           <input type="checkbox"  id="declare" [(ngModel)]="userDetails.declare">
                           &nbsp; I do hereby declare that all the information provided here is true to the 
                           best of my knowledge and belief. If anything found to be incorrect/false, I 
                           shall be solely responsible for any consequences arising thereon.
                        </div>
                     </div>
                  </div>
                  <div class="row">
                     <div class="col-md-12">       
                        <button type="submit" class="btn btn-danger" (click)="back()">
                        Cancel
                        </button>&nbsp;&nbsp;
                        <button type="submit" class="btn btn-info mx-2" style="float: right;" *ngIf="userDetails?.declare" (click)="onSubmit()">
                        Proceed to Payment
                        </button>&nbsp;&nbsp;
                     </div>
                  </div>
               </div>
            </div>
            <div class="clearfix"></div>
         </div>
      </div>
   </div>
</div>